import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { _x } from '@wordpress/i18n';

const zeroPad = (number) => (number < 10 ? '0' + number : number);
const MOBILE_MQ = '(max-width: 767px)';

domReady(() => {
  document.querySelectorAll('.team-grid-carreer-block').forEach((block) => {
    const swiperEl = block.querySelector('.swiper');

    if (!swiperEl) {
      return;
    }

    let swiper = null;
    const mql = window.matchMedia(MOBILE_MQ);

    const isAnimationDisabled = () =>
      document.documentElement.classList.contains('no-animation');

    const autoplayConfig = {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    };

    const initSwiper = () => {
      if (swiper) {
        return;
      }

      swiper = new Swiper(swiperEl, {
        modules: [Autoplay],
        slidesPerView: 1.15,
        spaceBetween: 15,
        autoplay: isAnimationDisabled() ? false : autoplayConfig,

        breakpoints: {
          600: {
            slidesPerView: 2.2,
            spaceBetween: 15,
          },
        },

        navigation: {
          prevEl: block.querySelector('.swiper-button-prev'),
          nextEl: block.querySelector('.swiper-button-next'),
        },

        pagination: {
          el: block.querySelector('.swiper-pagination'),
          type: 'fraction',
          formatFractionCurrent: zeroPad,
          formatFractionTotal: zeroPad,
        },

        a11y: {
          firstSlideMessage: _x(
            'This is the first slide',
            'carousel first slide label',
            'vtx'
          ),
          lastSlideMessage: _x(
            'This is the last slide',
            'carousel last slide label',
            'vtx'
          ),
          paginationBulletMessage: _x(
            'Go to slide {{index}}',
            'carousel navigation label',
            'vtx'
          ),
          prevSlideMessage: _x(
            'Previous slide',
            'carousel previous label',
            'vtx'
          ),
          nextSlideMessage: _x('Next slide', 'carousel next label', 'vtx'),
        },
      });
    };

    const destroySwiper = () => {
      if (!swiper) {
        return;
      }

      swiper.destroy(true, true);
      swiper = null;
    };

    const handleMQ = (e) => {
      if (e.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    };

    document.addEventListener('disable-animations', () => {
      if (swiper) {
        swiper.autoplay.stop();
      }
    });

    document.addEventListener('enable-animations', () => {
      if (swiper) {
        swiper.autoplay.start();
      }
    });

    mql.addEventListener('change', handleMQ);
    handleMQ(mql);
  });
});
